import { Avatar } from "shared/UI/Avatar/Avatar";
import { useState } from "react";

export function ComponentsWisdomRewards() {
  const [name, setName] = useState("");
  return (
    <div className="flex flex-col gap-4">
      <Avatar firstName={"Kim"} lastName={"Lise"} onClick={() => setName("Kim Lise")} />
      <Avatar firstName={"Ben"} lastName={"Johnson"} className="!h-24 !w-24 text-2xl" onClick={() => setName("Ben Johnson")} />
      <Avatar firstName={"Cindy"} lastName={"Renae"} className="!h-32 !w-32 text-5xl" onClick={() => setName("Cindy Renae")} />
      Name selected: {name}
    </div>
  );
}
